var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7391 20.4818V7.25731C27.7391 3.24921 24.4899 0 20.4818 0L7.25732 0C3.24922 0 1.14441e-05 3.24921 1.14441e-05 7.25731V20.4818C1.14441e-05 24.4899 3.24922 27.7391 7.25732 27.7391H20.4818C24.4899 27.7391 27.7391 24.4899 27.7391 20.4818Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1765 8.6416C17.6547 8.6416 17.2278 9.0685 17.2278 9.59976C17.2278 10.131 17.6547 10.5579 18.1765 10.5579C18.6982 10.5579 19.1346 10.131 19.1346 9.59976C19.1346 9.0685 18.7077 8.6416 18.1765 8.6416Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9359 9.86523C11.7255 9.86523 9.93256 11.6582 9.93256 13.8686C9.93256 16.079 11.7255 17.872 13.9359 17.872C16.1463 17.872 17.9393 16.079 17.9393 13.8686C17.9393 11.6582 16.1463 9.86523 13.9359 9.86523ZM13.9359 16.4395C12.5224 16.4395 11.3745 15.2916 11.3745 13.8781C11.3745 12.4646 12.5224 11.3167 13.9359 11.3167C15.3495 11.3167 16.4973 12.4646 16.4973 13.8781C16.4973 15.2916 15.3495 16.4395 13.9359 16.4395Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.114 21.9994H10.6251C7.93086 21.9994 5.73944 19.808 5.73944 17.1138V10.6249C5.73944 7.93068 7.93086 5.73926 10.6251 5.73926H17.114C19.8082 5.73926 21.9996 7.93068 21.9996 10.6249V17.1138C21.9996 19.808 19.8082 21.9994 17.114 21.9994ZM10.6251 7.26661C8.77518 7.26661 7.2668 8.775 7.2668 10.6249V17.1138C7.2668 18.9637 8.77518 20.4721 10.6251 20.4721H17.114C18.9639 20.4721 20.4723 18.9637 20.4723 17.1138V10.6249C20.4723 8.775 18.9639 7.26661 17.114 7.26661H10.6251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaLogo);
export default __webpack_public_path__ + "static/media/instaLogo.b14a9a4a90ebcf6b134754d85cfc9459.svg";
export { ForwardRef as ReactComponent };